import React from 'react';
import { createBrowserHistory } from 'history';
import { Provider } from 'mobx-react';
import { RouterStore } from '@superwf/mobx-react-router';
import { BrowserRouter } from 'react-router-dom';
import { MainFooter, RouterProvider } from 'telia-front-react';
import RootStore from './stores/RootStore';
import HeaderContainer from './header/HeaderContainer';
import FooterContainer from './footer/FooterContainer';
import MainContent from './MainContent';
import { getAppFromUrl } from './util/PathUtil';
import ApplicationLabelProvider from './wrapper/ApplicationLabelProvider';
import ApplicationThemeProvider from './wrapper/ApplicationThemeProvider';
import MainWrapper from './wrapper/MainWrapper';
import TranslationsContextWrapper from './wrapper/TranslationsContextWrapper';
import PageErrorBoundary from './error/PageErrorBoundary';
import ComponentErrorBoundary from './error/ComponentErrorBoundary';

const browserHistory = createBrowserHistory();
class App extends React.Component<InitialStateHolder> {
  private rootStore: RootStore;

  constructor(props: InitialStateHolder) {
    super(props);
    const routerStore = new RouterStore(browserHistory);
    if (props.initialState.serverContextPath) {
      routerStore.replace(props.initialState.serverContextPath);
    }
    this.rootStore = new RootStore(routerStore, props.initialState, props.app || getAppFromUrl(window.location.toString()));
  }

  public render() {
    return (
      <Provider {...this.rootStore}>
        <PageErrorBoundary app={this.rootStore?.app}>
          <BrowserRouter>
            <RouterProvider navigate={this.rootStore?.routeStore?.navigate}>
              <TranslationsContextWrapper translations={this.rootStore?.initialState?.translations}>
                <ApplicationThemeProvider>
                  <ApplicationLabelProvider>
                    <MainWrapper>
                      <HeaderContainer />
                      <ComponentErrorBoundary history={browserHistory}>
                        <MainContent />
                      </ComponentErrorBoundary>
                      <MainFooter>
                        <FooterContainer />
                      </MainFooter>
                    </MainWrapper>
                  </ApplicationLabelProvider>
                </ApplicationThemeProvider>
              </TranslationsContextWrapper>
            </RouterProvider>
          </BrowserRouter>
        </PageErrorBoundary>
      </Provider>
    );
  }
}

export default App;
